/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import { loadFonts } from './webfontloader';
import vuetify from './vuetify';
import pinia from '../store';
import router from '../router';
import VueGtag from 'vue-gtag';
import SolanaWallets from 'solana-wallets-vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import queryClient from './queryClient';
// Types
import type { App } from 'vue';

export function registerPlugins(app: App) {
  loadFonts();
  app
    .use(vuetify)
    .use(router)
    .use(pinia)
    .use(VueQueryPlugin, {
      queryClient,
    })
    .use(
      VueGtag,
      {
        pageTrackerScreenviewEnabled: true,
        config: { id: 'G-NSVPYRSPC9' },
        appName: 'SonarWatchFrontend',
      },
      router,
    )
    .use(SolanaWallets, {
      autoConnect: true,
    });
}
